/**
 * <BrandLogo /> (r7.6) — the tenant's logo where the platform shows the SNT mark. Platform tenant → <SntLogo />
 * unchanged; a tenant with logo_url → <img>; a tenant without one → its name set in the theme's serif.
 * The tenant's own mark links to the tenant home (`/`), exactly like the platform mark.
 */
import { Link } from 'react-router-dom';
import SntLogo from '@/components/common/SntLogo';
import { useTenantOptional } from '@/context/TenantContext';

export default function BrandLogo({ size = 36, variant = 'full', themed = true, to = '/', className = '' }) {
  const tenant = useTenantOptional();
  if (!tenant || tenant.isPlatform) return <SntLogo variant={variant} size={size} themed={themed} to={to} className={className} />;
  const { brand } = tenant;
  const inner = brand.logo_url ? (
    <img src={brand.logo_url} alt={brand.name} height={size} style={{ height: size, width: 'auto', maxWidth: 220, display: 'block', objectFit: 'contain' }} />
  ) : (
    <span style={{ fontFamily: 'var(--font-serif, "Fraunces")', fontSize: Math.round(size * 0.55), color: 'var(--snt-text)', whiteSpace: 'nowrap', lineHeight: 1 }}>
      {brand.name}
    </span>
  );
  return <Link to={to} className={`inline-flex items-center no-underline ${className}`} aria-label={brand.name}>{inner}</Link>;
}
